import { render, staticRenderFns } from "./save.vue?vue&type=template&id=2a814c78&scoped=true"
import script from "./save.vue?vue&type=script&setup=true&lang=js"
export * from "./save.vue?vue&type=script&setup=true&lang=js"
import style0 from "./save.vue?vue&type=style&index=0&id=2a814c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a814c78",
  null
  
)

export default component.exports